export default function StatCard({ icon: Icon, label, value, testId, accent = "text-[#0F6B4F]" }) {
  return (
    <div data-testid={testId} className="rounded-xl border border-[#0F6B4F]/10 bg-white p-5 shadow-[0_2px_10px_rgba(15,107,79,0.05)]">
      <div className="flex items-center justify-between">
        <p className="text-xs font-medium uppercase tracking-wide text-[#64748B]">{label}</p>
        {Icon && <Icon className={`h-4 w-4 ${accent}`} />}
      </div>
      <p className="mt-2 font-heading text-2xl font-bold text-[#1F2937]">{value}</p>
    </div>
  );
}
